/**
 * Текст помилки збереження для користувача (чиста функція): перше повідомлення валідації сервера (ProblemDetails errors), інакше
 * повідомлення помилки, інакше `fallback`.
 */
export function errorText(error: unknown, fallback: string): string {
  if (!error || typeof error !== 'object') return fallback;
  const e = error as { message?: unknown; errors?: Record<string, unknown> };
  const first = Object.values(e.errors ?? {}).flat().find((m) => typeof m === 'string' && m);
  if (typeof first === 'string') return first;
  return typeof e.message === 'string' && e.message && !/^HTTP \d+$/.test(e.message) ? e.message : fallback;
}
